import React from 'react'

const Expired = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
            fill="none">
            <g clip-path="url(#clip0_6532_48655)">
                <path d="M5 23H19" stroke="#CDCED2" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                <path d="M5 3H19" stroke="#CDCED2" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                <path
                    d="M17 23V18.828C16.9999 18.2976 16.7891 17.789 16.414 17.414L12 13L7.586 17.414C7.2109 17.789 7.00011 18.2976 7 18.828V23"
                    stroke="#CDCED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                <path
                    d="M7 3V7.172C7.00011 7.70239 7.2109 8.21101 7.586 8.586L12 13L16.414 8.586C16.7891 8.21101 16.9999 7.70239 17 7.172V3"
                    stroke="#CDCED2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_6532_48655">
                    <rect width="24" height="24" fill="currentColor" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Expired
